import { h, Host } from "@stencil/core";
export class FileUploadThumbnail {
    constructor() {
        this.fileType = "";
        this.file = null;
        this.fileName = "";
        this.fileInputId = "";
        this.isImageFile = false;
        this.iconName = "";
    }
    element;
    getIconName = () => {
        if (this.fileType === "application/pdf") {
            return "file-pdf";
        }
        else {
            return "file-generic";
        }
    };
    connectedCallback() {
        this.isImageFile = this.fileType.startsWith("image/");
    }
    componentDidLoad() {
        if (!this.isImageFile) {
            this.iconName = this.getIconName();
        }
        else {
            const img = this.element.ownerDocument.createElement("img");
            // @ts-expect-error Check for typing
            img.file = this.file;
            const reader = new FileReader();
            /* eslint-disable */
            reader.onload = (function (aImg) {
                /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
                return function (e) {
                    aImg.src = e.target.result;
                };
            })(img);
            // @ts-expect-error Check for typing
            reader.readAsDataURL(this.file);
            // Append the img element to the Shadow DOM
            // @ts-expect-error Check for typing
            this.element.shadowRoot.appendChild(img);
        }
    }
    /**
     * handle deletion of file
     */
    fileUploadDelete;
    onDelete = () => {
        this.fileUploadDelete.emit({ fileInputId: this.fileInputId });
    };
    render() {
        return (h(Host, { key: 'c33e5d4c7d9d05773ead15b5fdc83dc4c58ad007' }, !this.isImageFile && h("ux-icon", { key: 'eda1a5d2a5cfc61dcf5d386dcb1253a7f72a7b45', "aria-hidden": "true", name: this.iconName, weight: "light" }), h("button", { key: 'afe247da1183127de943cc5081cc2ccab3f67fe5', id: "delete-button", onClick: this.onDelete, type: "button" }, h("ux-icon", { key: '352c3ff0a8ab863b0abb575c9a8f098405d11ed6', "aria-hidden": "true", name: "bin", weight: "normal" })), h("ux-tooltip", { key: '60a14a07a5bd33bd893681ad2300bf3f98e47286', "tooltip-target": "img", align: "bottom" }, this.fileName)));
    }
    static get is() { return "ux-file-upload-thumbnail"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["file-upload-thumbnail.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["file-upload-thumbnail.css"]
        };
    }
    static get properties() {
        return {
            "fileType": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the file type of the associated file"
                },
                "attribute": "file-type",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "file": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "File | null",
                    "resolved": "File | null",
                    "references": {
                        "File": {
                            "location": "global",
                            "id": "global::File"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the fileitself to render an image thumbnail"
                },
                "defaultValue": "null"
            },
            "fileName": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the file name of the associated file"
                },
                "attribute": "file-name",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "fileInputId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "the data-file-input-id of the associated file input"
                },
                "attribute": "file-input-id",
                "reflect": false,
                "defaultValue": "\"\""
            }
        };
    }
    static get states() {
        return {
            "isImageFile": {},
            "iconName": {}
        };
    }
    static get events() {
        return [{
                "method": "fileUploadDelete",
                "name": "uxFileUploadDelete",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "handle deletion of file"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=file-upload-thumbnail.js.map
